import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Alert,
} from '@mui/material'
import Loading from 'components/Loading'
import { useAPI } from 'contexts/APIProvider'
import { useNurse } from 'contexts/NurseProvider'
import { useSnackBarAlert } from 'contexts/SnackBarAlertProvider'
import { isEmpty } from 'lodash'
import { NursePayout } from 'logic/NursePayout'
import React from 'react'

const NursePayoutHistory: React.FC = () => {
  const { nurse } = useNurse()
  const { api } = useAPI()
  const { showAlert } = useSnackBarAlert()
  const [records, setRecords] = React.useState<NursePayout[]>([])
  const [loading, setLoading] = React.useState<boolean>(false)

  const fetchRecords = React.useCallback(async () => {
    if (!nurse || nurse.stripe_step === 'NOT_STARTED' || nurse.stripe_step === 'PROCESSING') return
    try {
      setLoading(true)
      setRecords(await api.listNursePayouts(nurse.nurse_id))
    } catch (e) {
      showAlert('error', 'Error fetching payout history')
      console.error(e)
    } finally {
      setLoading(false)
    }
  }, [api, nurse, showAlert])

  React.useEffect(() => {
    fetchRecords()
  }, [fetchRecords])

  if (loading || !nurse) {
    return <Loading />
  } else if (isEmpty(records)) {
    return <Alert severity='info'>No Records Found</Alert>
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Est. Arrival Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record, i) => (
            <TableRow key={i}>
              <TableCell data-label='Date'>{record.created_date_label(nurse.tz)}</TableCell>
              <TableCell data-label='Amount'>{record.amount_label}</TableCell>
              <TableCell data-label='Status'>{record.status}</TableCell>
              <TableCell data-label='Est. Arrival Date'>{record.arrival_date_label(nurse.tz)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export default NursePayoutHistory